import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_GRADES } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveGradesActionType } from '../actions/saveGradesAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveGrades(action: SaveGradesActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/grades', action.headers, {
      esrog_id: action.esrogId,
      grades: action.grades,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Grades');
    }
  }
}

export function* watchSaveGrades() {
  yield takeEvery(SAVE_GRADES, saveGrades);
}
